module.exports = __webpack_public_path__ + "static/media/kjeveortoped.1d747ed0.mp3";